import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AccountMenu from './auth/AccountMenu';
import trackingService from '../services/tracking.service';
import logoHorizontalImg from '../assets/logo.png';
import '../styles/components/Navbar.scss';

export const Navbar = ({ children }) => {
  const { user } = useAuth();

  const handleLoginClick = () => {
    trackingService.trackLinkClick('login_nav', '/login', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleRegisterClick = () => {
    trackingService.trackLinkClick('register_nav', '/register', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handlePricingClick = () => {
    trackingService.trackLinkClick('pricing_nav', '/pricing', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleNewResearchClick = () => {
    trackingService.trackLinkClick('new_research_nav', '/new_research', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleTrendsClick = () => {
    trackingService.trackLinkClick('trends_nav', '/trends', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleAiKeywordsClick = () => {
    trackingService.trackLinkClick('ai_keywords_landing_nav', '/ai-keywords/landing', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleMockupClick = () => {
    trackingService.trackLinkClick('mockup_nav', '/mockup', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleReportsClick = () => {
    trackingService.trackLinkClick('reports_nav', '/reports', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleProjectsClick = () => {
    trackingService.trackLinkClick('projects_nav', '/user/projects', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  const handleLogoClick = () => {
    trackingService.trackLinkClick('logo_nav', '/', {
      page: 'navbar',
      user_authenticated: !!user
    });
  };

  return (
    <nav className="bg-card shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between navbar-inner">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link 
                to="/" 
                className="font-bold text-primary navbar-logo"
                onClick={handleLogoClick}
              >
                <img src={logoHorizontalImg} alt="Project Nous" className="navbar-logo-img" />
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              {/* <Link
                to="/showcase"
                className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 font-medium transition duration-150 navbar-link"
                onClick={handlePricingClick}
              >
                Showcase
              </Link> */}
              {/* <Link
                to="/pricing"
                className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 font-medium transition duration-150 navbar-link"
                onClick={handlePricingClick}
              >
                Pricing
              </Link> */}
              {/* <Link
                to="/new_research"
                className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition duration-150"
                onClick={handleNewResearchClick}
              >
                New Research
              </Link> */}
              {/* <Link
                to="/ai-keywords"
                className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 font-medium transition duration-150 navbar-link"
                onClick={handleTrendsClick}
              >
                AI Search Optimization
              </Link> */}
              {/* <Link
                to="/ai-keywords/landing"
                className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 font-medium transition duration-150 navbar-link"
                onClick={handleAiKeywordsClick}
              >
                AI Search Optimization
              </Link> */}
              {/* <Link
                to="/mockup"
                className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition duration-150"
                onClick={handleMockupClick}
              >
                Mockup
              </Link>
              {user && (
                <>
                  <Link
                    to="/new_research"
                    className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition duration-150"
                    onClick={handleNewResearchClick}
                  >
                    New Research
                  </Link>
                  <Link
                    to="/reports"
                    className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition duration-150"
                    onClick={handleReportsClick}
                  >
                    Reports
                  </Link>
                  <Link
                    to="/user/projects"
                    className="border-transparent text-text-secondary hover:text-text-primary hover:border-border-color inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition duration-150"
                    onClick={handleProjectsClick}
                  >
                    Projects
                  </Link>
                </>
              )} */}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {children}
            {user && <AccountMenu />}
            {!user && (
              <div className="flex space-x-4">
                <Link
                  to="/login"
                  className="navbar-login-button"
                  onClick={handleLoginClick}
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="navbar-signup-button"
                  onClick={handleRegisterClick}
                >
                  Sign up
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}; 
